export var version = "3.13.1";
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/version.js
// module id = 1055
// module chunks = 11